import { environment as base } from '@haleo-frontend/utils';

export const environment = {
    ...base,
    appId: 'ca.haleo.release',
    amplitudeKey: '21c61bf00a89d655d0dc49910a2cbd07',
    firebaseConfig: {
        apiKey: 'AIzaSyBYknWujY6a2HUNxzXMb4dExEnx_NXNgsk',
        authDomain: 'haleo-release.firebaseapp.com',
        projectId: 'haleo-release',
        storageBucket: 'haleo-release.appspot.com',
        messagingSenderId: '183354701772',
        appId: '1:183354701772:web:87486b60c157fbc7bacf69',
        measurementId: 'G-PQV5PGFCD8'
    },
    sentryDSN: 'https://0c5f0cb86920459cabec4f47ef4e0c2c@sentry-relay.haleo.ca/5593117',
    zoomWebSDKURL: 'https://haleo-release.firebaseapp.com/assets/html/zoom-external.html',
    appDynamicLink: 'https://haleoclinicrelease.page.link/back-to-app',
    growthBookKey: 'sdk-EvOa5FxC0EmdFE'
};
